import { capitalize } from "lodash-es";
import * as React from "react";
import { useParams } from "react-router";
import { useGetEventDetailQuery } from "src/queries/useGetEventDetailQuery";
import { formatTitleHeader } from "src/utils/formatUtils";
import EventInfoSections from "./EventInfoSections";
import EventSidebar from "./EventSidebar";
import { BackButton, Loader } from "@ic-anywhere/ic-components";
import { useGetMyInvitationsQuery } from "src/queries/useGetMyInvitationsQuery";

const EventDetail: React.FC = () => {
  const { id: eventId } = useParams<{ id: string }>();
  const { data: eventDetail, isLoading } = useGetEventDetailQuery(eventId, true);
  const { data: myInvitation, isLoading: isLoadingInvitation } = useGetMyInvitationsQuery(eventId);

  return (
    <div className="container-xxl mb-5" style={{ marginTop: "32px" }}>
      <div className="d-flex flex-column">
        <BackButton className="align-self-start" />
        <div className={"d-flex justify-content-center"}>
          <Loader isVisible={isLoading || isLoadingInvitation} />
        </div>
        {eventDetail && myInvitation && (
          <>
            <span className="mt-4 text-secondary">{formatTitleHeader(capitalize(eventDetail?.event.category))}</span>
            <h1 className="mt-3 mb-3">{formatTitleHeader(capitalize(eventDetail?.event.name))}</h1>
            <div className="d-flex flex-row gap-4">
              <EventInfoSections
                pictureLink={eventDetail.event.pictureLink}
                name={eventDetail.event.name}
                description={eventDetail.event.description}
                usefulInformation={eventDetail.event.usefulInformation}
              />
              <EventSidebar event={eventDetail.event} eventInvitationStatus={myInvitation?.status} />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default EventDetail;
